import WarningIcon from "@mui/icons-material/Warning";
import { Tooltip } from "@mui/material";

const WarningIconComponent = ({ title }: { title?: string | null }) => (
  <Tooltip
    title={title}
    placement="bottom"
    arrow
    slotProps={{
      popper: {
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -4],
            },
          },
        ],
      },
    }}
  >
    <WarningIcon
      sx={{
        color: "warning.main",
        fontSize: "14px",
      }}
    />
  </Tooltip>
);

export default WarningIconComponent;
